import { FC, PropsWithChildren } from 'react';

export const ObjectPreviewText: FC<PropsWithChildren> = ({ children }) => (
  <div className="m-[-1px] px-3 py-1 border border-solid border-tpg_light tpg-b2 text-tpg_title">
    {children}
  </div>
);
